const images = {
  uklogoBackgroundEmpty: require("./logo.png").default,
};

export default images;
